import React, { useEffect, useState } from "react";


export default function DumpTableSelector({ onChangeSelected }) {
    const [tables, setTables] = useState([]);
    const [selected, setSelected] = useState([]);
  
    useEffect(() => {
      fetch("/api/admin/dump/tables")
        .then((res) => res.json())
        .then((data) => setTables(data))
        .catch((err) => console.error("Ошибка загрузки таблиц:", err));
    }, []);
  
    useEffect(() => {
      onChangeSelected?.(selected);
    }, [selected]);
  
    const toggleTable = (tableName) => {
      setSelected((prev) =>
        prev.includes(tableName)
          ? prev.filter((t) => t !== tableName)
          : [...prev, tableName]
      );
    };
  

  return (
    <div>
      <h3>Выбор таблиц для дампа</h3>
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th></th>
            <th>Название</th>
            <th>Строк</th>
            <th>Размер (МБ)</th>
          </tr>
        </thead>
        <tbody>
          {tables.map((table) => (
            <tr key={table.name}>
              <td>
                <input
                  type="checkbox"
                  checked={selected.includes(table.name)}
                  onChange={() => toggleTable(table.name)}
                />
              </td>
              <td>{table.name}</td>
              <td>{table.rows}</td>
              <td>{table.size_mb}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p>Выбрано: {selected.length}</p>
      <pre>{JSON.stringify(selected, null, 2)}</pre>
    </div>
  );
}
